// Conteúdo do Catálogo Aggily 2025 (baseado no PDF cat_aggily_2025.pdf)
// Em produção usamos /api/catalogos para que o Nginx (proxy de /api) entregue as imagens pelo Node
const CATALOGO_BASE =
  process.env.NODE_ENV === 'production'
    ? '/api/catalogos'
    : `${(process.env.REACT_APP_API_URL || 'http://localhost:3005').replace(/\/api\/?$/, '')}/catalogos`;

export const CATALOGO_PDF_URL = `${CATALOGO_BASE}/cat_aggily_2025.pdf`;

/** URL base para imagens das páginas extraídas (lanc_2025/img/pag_001.png ... pag_038.png) */
export const CATALOGO_IMG_BASE = `${CATALOGO_BASE}/lanc_2025/img`;

/** Total de páginas do catálogo */
export const CATALOGO_TOTAL_PAGINAS = 38;

/** Gera a URL da imagem da página N (1 a 38) */
export function getCatalogoPageImageUrl(pageNum) {
  return `${CATALOGO_IMG_BASE}/pag_${String(pageNum).padStart(3, '0')}.png`;
}

export const INTRO_CATALOGO = `Os produtos Home Care Aggily são especializados na manutenção dos fios em casa. Envolvem fragrâncias incríveis e agentes hidratantes e nutritivos para um cabelo mais forte, saudável e com vida.`;

export const LINHAS_CATALOGO = [
  {
    titulo: 'Kit Argan Oil / Kit Silver Desamarelador Pro System',
    descricao: 'Restaura o tom dos cabelos coloridos, descoloridos ou naturalmente loiros. Matiza amarelados, nutre e ajuda a fortificar os fios, realçando um tom mais luminoso e platinado. Fórmula enriquecida com óleo de argan.',
  },
  {
    titulo: 'Kit Total Repair / BotoxX Therapy Matizador Pro System',
    descricao: 'Manutenção concentrada e rica em nutrientes, repara os fios danificados de dentro para fora. Contém Cistina, Óleo de Ojon orgânico, Óleo de Macadâmia e filtros UVA/UVB. BotoxX alia Argan ao Colágeno de Silicones.',
  },
  {
    titulo: 'Pré-escova e finalização',
    descricao: 'Creme Pré Escova Argan Oil, Aggi Obrigatório, Óleo de Argan, Sérum Termoativo, BB Cream. Proporcionam brilho intenso, saúde e proteção aos fios durante e após a escova.',
  },
  {
    titulo: 'Sérum para Loiras / Kit Day by Day / Máscara Recovery / Finish Repair',
    descricao: 'Revitaliza, repara e protege os fios prevenindo pontas duplas. Selagem de cutículas, ação antifrizz. Spray de brilho e máscara para cabelos com brilho excepcional.',
  },
  {
    titulo: 'Spray Fixador Aggifix / Charm Hair / Ativador de Cachos',
    descricao: 'Spray fixador que hidrata e modela os fios. Redutor de volume com óleo de macadâmia. Ativador de cachos e semidefinitiva que realça os cachos com óleo de argan.',
  },
  {
    titulo: 'Matizadores Maria Antonieta',
    descricao: 'Linha especializada no charme de cabelo de revista. Gloss Silver, AggiBlond, Black Platinum. Matizadores que eliminam tons amarelados e doam cor exclusiva e moderna.',
  },
  {
    titulo: 'BB Blond / Aggi Platinum',
    descricao: 'Kit para cabelos loiros com mechas, luzes e grisalhos. Ação desamareladora, fórmula com óleo de argan e Ojon. Spray matizador de ação instantânea.',
  },
  {
    titulo: 'Pro-System Aggily',
    descricao: 'Linha especializada em cabelos sem frizz e reconstruídos. Redutor Coconut Oil, Kit Argan Oil, Kit Redutor X-Liss. Liso intenso e brilho incomparável.',
  },
  {
    titulo: 'BTX Capilar / Bamboo e Babosa / Selagem Divinna',
    descricao: 'BTX Capilar Treatment com blend de aminoácidos. Selagem que reduz volume, anti-frizz, hidrata e devolve brilho. Indicado para cabelos danificados e crespos.',
  },
  {
    titulo: 'Matizadores Color – Gloss Aggi Red, Black, Marsala',
    descricao: 'Máscaras para reavivar cor e brilho dos cabelos pretos, vermelhos e marsala. Óleo de argan, queratina e hidratantes. Revitalizam e realçam as cores.',
  },
  {
    titulo: 'Gloss Aggi Ginger / Pink / Caramel',
    descricao: 'Realçam tons acobreados, rosa intenso e morena iluminada. Efeito condicionante, brilho radiante. Para ruivos, loiros e tons claros.',
  },
  {
    titulo: 'Coloração Aggycolor',
    descricao: 'Coloração creme permanente 60g, fórmula com macadâmia e óleo de argan. Trata e protege a fibra capilar, cor uniforme e viva da raiz às pontas.',
  },
  {
    titulo: 'Aggi Express / Emulsão Oxidante',
    descricao: 'Coloração ultrarrápida dos fios brancos (3 a 30 min). Uma bisnaga para várias nuances. Água oxigenada cremosa e agente estabilizante profissional.',
  },
  {
    titulo: 'Op\'s Blond',
    descricao: 'Linha para cabelos loiros e recuperação de fios tratados. Neutralizante pH Control, Reconstrução Op\'s Blond, Emulsão Oxidante Op\'s Supreme. Realinhamento térmico matizador.',
  },
  {
    titulo: 'Pó Descolorante / S.O.S Reconstrução',
    descricao: 'Pó descolorante para cabelos sensíveis, com óleo de macadâmia e argan. Clareador ultrarrápido com proteínas da seda. S.O.S para fios sensibilizados por químicas.',
  },
  {
    titulo: 'Linha Dondoca',
    descricao: 'Fios mais lisos, brilhosos e macios. Dtox Dondoca, Kit Home Care Dondoquinha, Redutor Dondoca. Botox Zero com hidratação profunda e zero formol.',
  },
  {
    titulo: 'Kit Louca por Cachos',
    descricao: 'Manutenção para cabelos cacheados, NoPoo e LowPoo. Hidratação e nutrição intensa, combate ao frizz e ressecamento.',
  },
  {
    titulo: 'Reconstrutores – Aggi Hydra Milk / Upgrade Hair',
    descricao: 'Máscara Aggi Hydra Milk com proteína do leite. Reconstrutor Upgrade Hair em 2 passos para cauterização e selagem das cutículas.',
  },
  {
    titulo: 'Lavatório – Argan Oil / Camu-Camu / Mandioca',
    descricao: 'Linha para salões. Shampoo e condicionador 5L. Argan Oil, Camu-Camu para crescimento, Mandioca para cabelos opacos.',
  },
  {
    titulo: 'Máscara Micelar / Aggi Intense',
    descricao: 'Máscara micelar que remove resíduos e hidrata. Shampoo Aggi Intense com mix de 7 óleos, livre de sal.',
  },
  {
    titulo: 'Cronograma Capilar',
    descricao: 'Hidratação, Nutrição e Reconstrução em rotina de 4 semanas. Para todos os tipos de cabelo e texturas.',
  },
  {
    titulo: 'Plástica de Argila / Salva Plex SOS',
    descricao: 'Kit argila reconstrutor: hidrata, traz queratina, remove oleosidade e toxinas. Tratamento completo para fios danificados.',
  },
  {
    titulo: 'Linha Óleos Nobres',
    descricao: 'Para cabelos opacos, ressecados e porosos. Óleos nobres, manteigas e aminoácidos. Jojoba, buriti, argan, coco, karité, manga e colágeno.',
  },
  {
    titulo: 'Linha UAU Dream Hair',
    descricao: 'Spray e máscara com creatina, aminoácidos e pantenol. Controle do frizz, proteção anti-umidade, brilho iluminador e reestruturação da fibra.',
  },
  {
    titulo: 'Aggi Nails',
    descricao: 'Amolecedor de cutículas e Perfect Drier secante de esmalte. Hidratação intensa e secagem rápida para unhas.',
  },
];
